// /components/ErrorBoundary.js
import React from 'react';
import { Box, Typography, Button, Tooltip } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for further analysis
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReload = () => {
    // Optionally reset error state and reload the page
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ textAlign: 'center', p: 4 }}>
          <Typography
            variant="h4"
            color="error"
            gutterBottom
          >
            Oops! Something went wrong.
          </Typography>
          <Typography
            variant="body1"
            sx={{ mb: 2 }}
          >
            We're sorry for the inconvenience. Our team has been notified and is working to resolve the issue. Please
            try refreshing the page. If the problem persists, feel free to contact our support team.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleReload}
          >
            Refresh Page
          </Button>
          {this.state.error && (
            <Box sx={{ mt: 2 }}>
              <Typography
                variant="caption"
                color="textSecondary"
              >
                <Tooltip title={this.state.errorInfo?.componentStack}>
                  <span>{this.state.error.toString()}</span>
                </Tooltip>
              </Typography>
            </Box>
          )}
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
